import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Box } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {
  ContainerSection,
  MAutocomplete,
  MButton,
  MDatePicker,
  ResponsiveFormContainer,
} from "@app/components";
import { useBackground } from "../utils/useBackground";
import { IFormBackground } from "@app/types/background.types";
import { PROCESS_OPTIONS, MEDIO_FILTER_OPTIONS } from "../utils/constans";
import { yearsTable } from "@app/utils/tables/years.tables";
import { monthsTable } from "@app/utils/tables/months.tables";
import { useEquipment } from "@services/servicesGenericsTables";

const FilterBackground = () => {
  const { setQuery } = useBackground();
  const form = useForm<IFormBackground>({ mode: "all" });
  const { equipmentList } = useEquipment();

  const submit = (data: IFormBackground) => {
    setQuery(data);
  };

  const clearFilters = () => {
    form.reset();
    setQuery({});
  };

  return (
    <ContainerSection label="Filtros">
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(submit)}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <ResponsiveFormContainer columns={5}>
              <MAutocomplete
                key={JSON.stringify(form.getValues("process"))}
                name="process"
                options={PROCESS_OPTIONS}
                label="Seleccione un proceso"
                getOptionLabel={(option) => option.value}
              />
              <MAutocomplete
                key={JSON.stringify(form.watch("year"))}
                name="year"
                options={yearsTable}
                label="Año"
                getOptionLabel={(option) => `${option}`}
              />
              <MAutocomplete
                key={JSON.stringify(form.getValues("month"))}
                name="month"
                options={monthsTable}
                label="Seleccione un mes"
              />
              <MAutocomplete
                key={JSON.stringify(form.getValues("equipment"))}
                name="equipment"
                options={equipmentList || []}
                label="Seleccione un Equipo"
                getOptionLabel={(option) =>
                  `${option.codigo} - ${option.descripcion}` || ""
                }
                multiple={true}
              />
              <MAutocomplete
                name="filter_medium"
                options={MEDIO_FILTER_OPTIONS || []}
                label="Seleccione un medio filtro"
                getOptionLabel={(option) => option.label}
                multiple={true}
              />
              <MDatePicker
                name="start_date"
                pickerType="date"
                label="Fecha creación desde"
              />
              <MDatePicker
                name="end_date"
                pickerType="date"
                label="Fecha creación hasta"
              />
              <MDatePicker
                name="start_calculation_date"
                pickerType="date"
                label="Fecha cálculo desde"
              />
              <MDatePicker
                name="end_calculation_date"
                pickerType="date"
                label="Fecha cálculo hasta"
              />
            </ResponsiveFormContainer>
            <Box sx={{ display: "flex", alignItems: "center", ml: 2 }}>
              <MButton
                variant="outlined"
                color="primary"
                sx={{ textTransform: "uppercase" }}
                text="Filtrar"
                type="submit"
                startIcon={<FilterAltIcon />}
              />
              <MButton
                variant="outlined"
                color="secondary"
                sx={{ textTransform: "uppercase", ml: 2 }}
                text="Limpiar"
                onClick={clearFilters}
              />
            </Box>
          </Box>
        </form>
      </FormProvider>
    </ContainerSection>
  );
};

export default FilterBackground;
